import Application from "../../Application";
import Area, { IArea } from "../../core/areas/Area";
import { IRouter } from "../../runtime/Router";
import CreateIndexTypeCategoryInteractor from "../interactors/CreateIndexTypeCategoryInteractor";
import CreateIndexTypeGroupInteractor from "../interactors/CreateIndexTypeGroupInteractor";
import CreateIndexTypeInteractor from "../interactors/CreateIndexTypeInteractor";
import GetAllIndexTypeCategoriesInteractor from "../interactors/GetAllIndexTypeCategoriesInteractor";
import GetAllIndexTypesInteractor from "../interactors/GetAllIndexTypesInteractor";
import GetAllIndexTypeGroupsInteractor from "../interactors/GetAllIndexTypeGroupsInteractor";
import ShowIndexTypeCategoriesInteractor from "../interactors/ShowIndexTypeCategoriesInteractor";
import ShowIndexTypeGroupsInteractor from "../interactors/ShowIndexTypeGroupInteractor";
import IndexTypeGroupListPage from "../ui/pages/IndexTypeGroupPage";
import GetAllGroupChildGroupsInteractor from "../interactors/GetAllGroupChildGroupsInteractor";
import GetAllGroupItemsInteractor from "../interactors/GetAllGroupItemsInteractor";
import IndexTypeCategoryListPage from "../ui/pages/IndexTypeCategoryListPage";
import AssignGroupChildrenGroupsInteractor from "../interactors/AssignGroupChildrenGroupsInteractor";
import AssignGroupItemsInteractor from "../interactors/AssignGroupItemsInteractor";
import FindIndexTypeGroupInteractor from "../interactors/FindIndexTypeGroupInteractor";
import ShowIndexTypeGroupDetailsInteractor from "../interactors/ShowGroupDetailsInteractor";
import IndexTypeGroupDetailsPage from "../ui/pages/IndexTypeGroupDetailsPage";
import GetAllIndexTypeGroupsForCategoryInteractor from "../interactors/GetAllIndexTypeGroupsForCategory";
import UpdateIndexTypeCategoryInteractor from "../interactors/UpdateIndexTypeCategoryInteractor";
import ShowIndexTypesInteractor from "../interactors/ShowIndexTypesInteractor";
import UpdateIndexGroupTypeInteractor from "../interactors/UpdateIndexGroupTypeInteractor";
import DeleteIndexGroupTypeInteractor from "../interactors/DeleteIndexGroupTypeInteractor";
import UpdateIndexTypeInteractor from "../interactors/UpdateIndexTypeInteractor";
import DeleteIndexTypeInteractor from "../interactors/DeleteIndexTypeInteractor";
import FindConnectionCandidatesForCategoryInteractor from "../interactors/FindConnectionCandidatesForCategoryInteractor";
import IndexTypesPage from "../ui/pages/IndexTypesPage";
import ConnectIndexTypeCategoriesInteractor from "../interactors/ConnectIndexTypeCategoriesInteractor";
import GetAllIndexTypeAttributesInteractor from "../interactors/GetAllIndexTypeAttributesInteractor";
import CreateIndexTypeAttributesInteractor from "../interactors/CreateIndexTypeAttributesInteractor";
import DeleteIndexTypeAttributesInteractor from "../interactors/DeleteIndexTypeAttributesInteractor";
import CreateIndexAttributeDataInteractor from "../interactors/CreateIndexAttributeDataInteractor";
import GetIndexAttributeDataByIndexInteractor from "../interactors/GetIndexAttributeDataByIndexInteractor";
import GetIndexAttributeDataByTypeInteractor from "../interactors/GetIndexAttributeDataByTypeInteractor";
import ShowCategoryIndexBulkEditorInteractor from "../interactors/ShowCategoryIndexBulkEditorInteractor";
import CategoryBulkEditorPage from "../ui/pages/CategoryBulkEditorPage";

export default class IndexTypeArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor({
    application,
    router
  }: {
    application: Application;
    router: IRouter;
  }) {
    super();
    this.application = application;
    this.router = router;
  }

  private registerModules() {
    const container = this.application.container;
    container.registerInteractor(
      "getAllIndexTypes",
      GetAllIndexTypesInteractor
    );
    container.registerInteractor(
      "getAllIndexTypeGroups",
      GetAllIndexTypeGroupsInteractor
    );
    container.registerInteractor(
      "getAllIndexTypeGroupsForCategory",
      GetAllIndexTypeGroupsForCategoryInteractor
    );
    container.registerInteractor(
      "getAllIndexTypeCategories",
      GetAllIndexTypeCategoriesInteractor
    );
    container.registerInteractor(
      "createIndexTypeCategory",
      CreateIndexTypeCategoryInteractor
    );
    container.registerInteractor(
      "createIndexTypeCategory",
      CreateIndexTypeCategoryInteractor
    );
    container.registerInteractor(
      "getAllGroupChildGroups",
      GetAllGroupChildGroupsInteractor
    );
    container.registerInteractor(
      "getAllGroupItems",
      GetAllGroupItemsInteractor
    );
    container.registerInteractor(
      "findIndexTypeGroup",
      FindIndexTypeGroupInteractor
    );
    container.registerInteractor(
      "assignGroupItems",
      AssignGroupItemsInteractor
    );
    container.registerInteractor(
      "assignGroupChildrenGroups",
      AssignGroupChildrenGroupsInteractor
    );
    container.registerInteractor(
      "showIndexTypeGroups",
      ShowIndexTypeGroupsInteractor
    );
    container.registerInteractor(
      "showIndexTypeCategories",
      ShowIndexTypeCategoriesInteractor
    );
    container.registerInteractor("createIndexType", CreateIndexTypeInteractor);
    container.registerInteractor(
      "createIndexTypeGroup",
      CreateIndexTypeGroupInteractor
    );
    container.registerInteractor(
      "showIndexTypeGroupDetails",
      ShowIndexTypeGroupDetailsInteractor
    );
    container.registerInteractor(
      "updateIndexTypeCategory",
      UpdateIndexTypeCategoryInteractor
    );
    container.registerInteractor("showIndexTypes", ShowIndexTypesInteractor);
    container.registerInteractor(
      "updateIndexGroupType",
      UpdateIndexGroupTypeInteractor
    );
    container.registerInteractor(
      "deleteIndexGroupType",
      DeleteIndexGroupTypeInteractor
    );
    container.registerInteractor("updateIndexType", UpdateIndexTypeInteractor);
    container.registerInteractor("deleteIndexType", DeleteIndexTypeInteractor);
    container.registerInteractor(
      "findConnectionCandidatesForCategory",
      FindConnectionCandidatesForCategoryInteractor
    );
    container.registerInteractor(
      "connectIndexTypeCategories",
      ConnectIndexTypeCategoriesInteractor
    );
    container.registerInteractor(
      "getAllIndexTypeAttributes",
      GetAllIndexTypeAttributesInteractor
    );
    container.registerInteractor(
      "createIndexTypeAttributes",
      CreateIndexTypeAttributesInteractor
    );
    container.registerInteractor(
      "deleteIndexTypeAttributes",
      DeleteIndexTypeAttributesInteractor
    );
    container.registerInteractor(
      "createIndexAttributeData",
      CreateIndexAttributeDataInteractor
    );
    container.registerInteractor(
      "getIndexAttributeDataByIndex",
      GetIndexAttributeDataByIndexInteractor
    );
    container.registerInteractor(
      "getIndexAttributeDataByType",
      GetIndexAttributeDataByTypeInteractor
    );
    container.registerInteractor(
      "showCategoryIndexBulkEditor",
      ShowCategoryIndexBulkEditorInteractor
    );
  }
  register(params: any) {
    this.registerModules();

    this.router.registerRoutes({
      path: "/index-type-categories",
      page: this.createPage({
        Page: IndexTypeCategoryListPage,
        action: this.showIndexTypeCategoryListPage.bind(this)
      }),
      options: {
        secure: true
      }
    });

    this.router.registerRoutes({
      path: "/index-type-groups",
      page: this.createPage({
        Page: IndexTypeGroupListPage,
        action: this.showIndexTypeGroupListPage.bind(this)
      }),
      options: {
        secure: true
      }
    });

    this.router.registerRoutes({
      path: "/index-type-categories/:id/groups",
      page: this.createPage({
        Page: IndexTypeGroupListPage,
        action: this.showIndexTypeGroupListPage.bind(this)
      }),
      options: {
        secure: true
      }
    });
    this.router.registerRoutes({
      path: "/index-type-categories/:id/groups/:groupId",
      page: this.createPage({
        Page: IndexTypeGroupDetailsPage,
        action: this.showIndexTypeGroupDetailsPage.bind(this)
      }),
      options: {
        secure: true
      }
    });
    this.router.registerRoutes({
      path: "/index-types",
      page: this.createPage({
        Page: IndexTypesPage,
        action: this.showIndexTypesPage.bind(this)
      }),
      options: {
        secure: true
      }
    });
    this.router.registerRoutes({
      path: "/category-editor/:id",
      page: this.createPage({
        Page: CategoryBulkEditorPage,
        action: this.showCategoryIndexBulkEditor.bind(this)
      }),
      options: {
        secure: true
      }
    });
  }

  public showIndexTypeGroupListPage({ id }: { id: string }) {
    return this.application.container
      .resolve<ShowIndexTypeGroupsInteractor>("showIndexTypeGroups")
      .execute(Number.parseInt(id, 10));
  }
  public showIndexTypeGroupDetailsPage({
    id,
    groupId
  }: {
    id: string;
    groupId: string;
  }) {
    return this.application.container
      .resolve<ShowIndexTypeGroupDetailsInteractor>("showIndexTypeGroupDetails")
      .execute(Number.parseInt(groupId, 10));
  }
  public showIndexTypeCategoryListPage() {
    return this.application.container
      .resolve<ShowIndexTypeCategoriesInteractor>("showIndexTypeCategories")
      .execute();
  }
  public showIndexTypesPage() {
    return this.application.container
      .resolve<ShowIndexTypesInteractor>("showIndexTypes")
      .execute();
  }
  public showCategoryIndexBulkEditor({ id }: { id: string }) {
    return this.application.container
      .resolve<ShowCategoryIndexBulkEditorInteractor>(
        "showCategoryIndexBulkEditor"
      )
      .execute(Number.parseInt(id, 10));
  }
}
